import { Box, BoxProps } from "@chakra-ui/react";

function MoreIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="20" height="20" rx="10" fill="#E4E4FF" />
        <path
          d="M9.996 10H10.0005"
          stroke="#1819B4"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99209 13H9.99658"
          stroke="#1819B4"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.9999 7H10.0044"
          stroke="#1819B4"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}

export { MoreIcon };
